import { BaseButton } from "@/shared/ui/BaseButton";
import { BaseDialog } from "@/shared/ui/base-dialog";
import {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

type Props = {
  open: boolean;
  onClose: () => void;
  onDelete: () => void;
  vehicleName?: string;
  driverName?: string;
};

export const ConfirmDeleteScheduledCarrierDialog = ({
  open,
  onClose,
  onDelete,
  vehicleName,
  driverName,
}: Props) => {
  const getDisplayText = () => {
    if (vehicleName && driverName) {
      return `「${vehicleName}（${driverName}）」の`;
    }
    if (vehicleName) {
      return `「${vehicleName}」の`;
    }
    if (driverName) {
      return `「${driverName}」の`;
    }
    return "";
  };

  return (
    <BaseDialog open={open} onClose={onClose}>
      <DialogTitle>配送予定車両を削除しますか？</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {getDisplayText()}
          配送予定車両を削除します。この操作は元に戻すことができません。
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <BaseButton onClick={onClose}>キャンセル</BaseButton>
        <BaseButton variant="contained" color="error" onClick={onDelete}>
          削除
        </BaseButton>
      </DialogActions>
    </BaseDialog>
  );
};
